export default __webpack_public_path__ + "static/media/137asset_3.fa368a52.png";